import { Target, Shield, Users, Award } from "lucide-react";

export const AboutSection = () => {
  const features = [
  {
    icon: Target,
    title: "Precisione",
    description: "Addestramento tattico avanzato e simulazioni realistiche per operatori di ogni livello."
  },
  {
    icon: Shield,
    title: "Sicurezza",
    description: "Protocolli rigorosi e attrezzature certificate per garantire il massimo divertimento in sicurezza."
  },
  {
    icon: Users,
    title: "Squadra",
    description: "Spirito di corpo e cameratismo. Insieme siamo più forti, sul campo e fuori."
  },
  {
    icon: Award,
    title: "Eccellenza",
    description: "Anni di esperienza e partecipazioni a eventi di interesse nazionale ci rendono un punto di riferimento."
  }];


  return (
    <section 
      id="chi-siamo" 
      data-testid="about-section" 
      className="section-tactical py-10 bg-tactical-bg hex-pattern"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-[2px] bg-tactical-primary" />
              <span className="font-mono text-xs text-tactical-primary tracking-widest uppercase">
                Chi Siamo
              </span>
            </div>
            
            <h2
              data-testid="about-title"
              className="font-heading font-bold text-4xl sm:text-5xl tracking-wider text-tactical-text uppercase mb-6">

              LA NOSTRA <span className="text-tactical-primary">STORIA</span>
            </h2>
            
            <div className="space-y-4 font-body text-tactical-text-muted">
              <p>
                <span className="text-tactical-primary font-semibold">Ghost Division A.S.D.</span> nasce nel 2016 a Sassari dalla 
                passione condivisa di un gruppo di amici per il softair e le simulazioni tattiche.
              </p>
              <p>
                La nostra missione è offrire e vivere esperienze di gioco immersive e realistiche, mantenendo 
                sempre al primo posto la sicurezza e il fair play. Organizziamo e partecipiamo a eventi softair che spaziano 
                dalle partite veloci ai MILSIM di 24 ore.
              </p>
              <p>
                Che tu sia un veterano o un neofita che vuole avvicinarsi a questo mondo, 
                troverai in noi una community accogliente e professionale.
              </p>
            </div>

            {/* Stats inline */}
            <div className="grid grid-cols-3 gap-6 mt-8 pt-8 border-t border-tactical-border">
              <div>
                <div className="font-heading font-bold text-3xl text-tactical-primary">2016</div>
                <div className="font-mono text-xs text-tactical-text-muted uppercase">Fondazione</div>
              </div>
              <div>
                <div className="font-heading font-bold text-3xl text-tactical-primary">10+</div>
                <div className="font-mono text-xs text-tactical-text-muted uppercase">Membri</div>
              </div>
              <div>
                <div className="font-heading font-bold text-3xl text-tactical-primary">10+</div>
                <div className="font-mono text-xs text-tactical-text-muted uppercase">Eventi Annuali</div>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative overflow-hidden border border-tactical-border">
              <img
                // src="https://images.unsplash.com/photo-1637594619207-400eb95a3f9e?q=80&w=2070&auto=format&fit=crop"
                src="/gallery/patch.jpeg"
                alt="Ghost Division Team"
                className="w-full h-[500px] object-cover filter saturate-[0.8]" />

              <div className="absolute inset-0 bg-gradient-to-t from-tactical-bg via-transparent to-transparent" />
              
              {/* Corner markers */}
              <div className="corner-marker corner-marker-tl" />
              <div className="corner-marker corner-marker-tr" />
              <div className="corner-marker corner-marker-bl" />
              <div className="corner-marker corner-marker-br" />
            </div>
            
            {/* Floating badge */}
            <div className="absolute -bottom-6 -left-6 bg-tactical-primary p-6">
              <div className="font-heading font-bold text-4xl text-black">10+</div>
              <div className="font-mono text-xs text-black/70 uppercase">Anni di Esperienza</div>
            </div>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-24">
          {features.map((feature, index) =>
          <div
            key={index}
            data-testid={`feature-card-${index}`}
            className="bg-tactical-surface border border-tactical-border p-6 group hover:border-tactical-primary/50 transition-colors">

              <feature.icon className="w-10 h-10 text-tactical-primary mb-4 group-hover:scale-110 transition-transform" />
              <h3 className="font-heading font-bold text-lg tracking-wider text-tactical-text uppercase mb-2">
                {feature.title}
              </h3>
              <p className="font-body text-sm text-tactical-text-muted">
                {feature.description}
              </p>
            </div>
          )}
        </div>
      </div>
    </section>);

};